import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Zap, FileText, Baby, CreditCard, Lock } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-12 pb-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto flex flex-col items-center text-center" data-id="element-150">
      <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="mb-8" data-id="element-151">
        <span className="text-gold-400 font-semibold tracking-wider uppercase text-sm md:text-base flex items-center justify-center gap-2" data-id="element-152">
          🌙 MUNDO RECURSOS™
        </span>
      </motion.div>

      <motion.h1 initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      delay: 0.1
    }} className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight" data-id="element-153">
        Tu bebé puede dormir mejor. <br className="hidden md:block" data-id="element-154" />
        <span className="text-gold-400" data-id="element-155">Desde esta noche.</span>
      </motion.h1>

      <motion.p initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      delay: 0.2
    }} className="text-lg md:text-xl text-blue-100 max-w-3xl mx-auto mb-10" data-id="element-156">
        El sistema práctico para padres primerizos que están agotados y
        necesitan un plan real — no más consejos sueltos de internet
      </motion.p>

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.8,
      delay: 0.3
    }} className="relative w-full max-w-2xl mx-auto mb-12" data-id="element-157">
        <div className="absolute inset-0 bg-gold-500/20 blur-3xl rounded-full" data-id="element-158"></div>
        <img src="https://cdn.magicpatterns.com/uploads/4r6ti11VFSAertbWSf37zC/Diseno_sin_titulo.png" alt="Kit SOS Nocturno" className="relative z-10 w-full h-auto drop-shadow-2xl rounded-xl" data-id="element-159" />
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      delay: 0.4
    }} className="flex flex-wrap justify-center gap-4 md:gap-8 mb-10 text-sm md:text-base font-medium text-blue-50" data-id="element-160">
        <div className="flex items-center gap-2" data-id="element-161">
          <FileText className="w-5 h-5 text-gold-400" data-id="element-162" /> 100% PDF
        </div>
        <div className="flex items-center gap-2" data-id="element-163">
          <Zap className="w-5 h-5 text-gold-400" data-id="element-164" /> Acceso inmediato
        </div>
        <div className="flex items-center gap-2" data-id="element-165">
          <Baby className="w-5 h-5 text-gold-400" data-id="element-166" /> 0 a 24 meses
        </div>
        <div className="flex items-center gap-2" data-id="element-167">
          <Shield className="w-5 h-5 text-gold-400" data-id="element-168" /> Garantía 7 días
        </div>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      delay: 0.5
    }} className="w-full max-w-md mx-auto" data-id="element-169">
        <a href="https://www.mundorecursos.store/cart/45107830423631:1" className="block w-full py-4 px-8 bg-gradient-to-r from-gold-500 to-gold-400 hover:from-gold-400 hover:to-gold-300 text-navy-900 font-bold text-lg md:text-xl rounded-full shadow-[0_0_20px_rgba(212,168,83,0.4)] hover:shadow-[0_0_30px_rgba(212,168,83,0.6)] transition-all transform hover:-translate-y-1" data-id="element-170">
          🌙 → QUIERO MI KIT SOS NOCTURNO AHORA
        </a>

        <div className="mt-6 flex flex-wrap justify-center items-center gap-3 text-xs md:text-sm text-blue-200/70" data-id="element-171">
          <div className="flex items-center gap-1" data-id="element-172">
            <CreditCard className="w-4 h-4" data-id="element-173" /> Mercado Pago
          </div>
          <span data-id="element-174">|</span>
          <div data-id="element-175">Tarjeta</div>
          <span data-id="element-176">|</span>
          <div data-id="element-177">Transferencia</div>
          <span data-id="element-178">|</span>
          <div className="flex items-center gap-1" data-id="element-179">
            <Lock className="w-4 h-4" data-id="element-180" /> Pago seguro
          </div>
        </div>
      </motion.div>
    </section>;
}